import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as Styles from './styles'
import * as Strings from './strings'

class NotFound extends Component {
  render() {
    const { language } = this.props
    return (
      <div style={Styles.default.containerStyle}>
        <h3 style={Styles.default.header}>
          {Strings.default.NOT_FOUND[language]}
        </h3>
        <p>{Strings.default.PAGE_DOES_NOT_EXIST[language]}</p>
      </div>
    )
  }
}

function mapStateToProps({ config }) {
  const { language } = config
  return { language }
}

export default connect(
  mapStateToProps,
  null
)(NotFound)



// WEBPACK FOOTER //
// ./src/components/pages/other/NotFound/index.js